<template>
    <button :disabled="loading || disabled">
        <template v-if="loading">
            <i class="fa fa-circle-notch fa-spin fa-1x fa-fw" /> {{ loadingText === '' ? $t('actions.processing') : loadingText }}
        </template>
        <slot v-else />
    </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: '',
        },
    }
};
</script>
